class PopupModal extends HTMLElement {
  static observedAttributes = ["open"];

  constructor() {
    super();
    this.style.visibility = 'hidden';

    this.elSection = this.closest('.shopify-section');

    if(this.hasAttribute('data-shopify-editor-block')) {
      document.addEventListener('shopify:block:select', ({ detail }) => {
        const blockData = JSON.parse(this.getAttribute('data-shopify-editor-block'));
        const { id } = blockData;
        id == detail.blockId ? this.setAttribute('open', true) : this.close();
      });
    } else {
      document.addEventListener('shopify:section:select', ({ detail }) => {
        let sectionId = `shopify-section-${detail.sectionId}`;
        this.elSection && this.elSection.id == sectionId ? this.setAttribute('open', true) : this.close();
      });
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(name == 'open') {
      if(newValue == "true") {
        this.open = true;
        this.style.visibility = 'visible';
        this.ariaHidden = false;
        this.tabIndex = 0;
        this.trapFocus();
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.closeOnFocus);
      } else {
        this.open = false;
        setTimeout(() => {
          this.style.visibility = 'hidden';
          this.ariaHidden = true;
          this.tabIndex = -1;
        }, 300);
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.closeOnFocus);
      }
    }
  }

  close() {
    this.setAttribute('open', false);
  }

  trapFocus() {
    const focusableElements = 'button, a, [href], input, select, textarea, [tabindex="0"]';
    const firstFocusableElement = this.querySelectorAll(focusableElements)[0];

    firstFocusableElement && setTimeout(() => firstFocusableElement.focus({ preventScroll: true }), 0);
  }

  closeOnFocus(ev) {
    let isTabPressed = ev.key === 'Tab';
    if (!isTabPressed) return;
    
    let hasFocus = this.contains(document.activeElement);
    !hasFocus && this.close();
  }
}

customElements.define('popup-modal', PopupModal);

